import { render, staticRenderFns } from "./v_Player.vue?vue&type=template&id=35d7d418&scoped=true&"
import script from "./v_Player.vue?vue&type=script&lang=js&"
export * from "./v_Player.vue?vue&type=script&lang=js&"
import style0 from "./v_Player.vue?vue&type=style&index=0&id=35d7d418&prod&scoped=true&class=scss&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d7d418",
  null
  
)

export default component.exports